import React, { useState, useEffect } from "react";
import { clearInterval, setInterval } from 'worker-timers';

const Countdown = ({ setCounting, setSendingLink }) => {
  const [counter, setCounter] = useState(0);
  const [startTime] = useState(new Date().getTime());
  const timeLeft = 120 - counter;

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter(Math.floor((new Date().getTime() - startTime) / 1000));
    }, 10);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!timeLeft) {
      setCounting(false);
      setSendingLink(false);
    }
  }, [counter]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secondsLeft = seconds % 60;
    return `${minutes}:${secondsLeft < 10 ? "0" : ""}${secondsLeft}`;
  };

  return <>{formatTime(timeLeft)}</>;
};

export default Countdown;
